import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=5871f181&scoped=true"
import script from "./VenueList.vue?vue&type=script&lang=js"
export * from "./VenueList.vue?vue&type=script&lang=js"
import style0 from "./VenueList.vue?vue&type=style&index=0&id=5871f181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871f181",
  null
  
)

export default component.exports